const watermark = {};
const setWatermark = (text, sourceBody) => {
	budo_log.info("#3 text: ", text);
	let id = "watermark_fjq_" + parseInt(Math.random() * 100000);
	if (document.getElementById(id) !== null) {
		document.body.removeChild(document.getElementById(id));
	}
	const can = document.createElement("canvas");
	const { width } = window.screen;
	can.width = width / 3;
	can.height = 220;
	const cans = can.getContext("2d");
	cans.rotate((-20 * Math.PI) / 180);
	cans.font = '15px "Hiragino Sans GB", "Microsoft YaHei", "WenQuanYi Micro Hei"';
	cans.fillStyle = "rgb(200, 200, 200)"; //水印颜色
	cans.textAlign = "left";
	cans.textBaseline = "Middle";
	cans.fillText(text, can.width / 10, can.height);
	const water_div = document.createElement("div");
	water_div.id = id;
	water_div.style.pointerEvents = "none";
	water_div.style.overflow = "hidden";
	water_div.style.background =
		"url(" + can.toDataURL("image/png") + ") left top repeat";
	if (sourceBody) {
		sourceBody.style.position = "relative";
		water_div.style.width = "100%";
		water_div.style.height = "100%";
		water_div.style.position = "absolute";
		water_div.style.top = "0";
		water_div.style.left = "0";
		sourceBody.appendChild(water_div);
	} else {
		water_div.style.top = "0";
		water_div.style.left = "0";
		water_div.style.position = "absolute";
		water_div.style.zIndex = "9999";
		water_div.style.width = document.documentElement.offsetWidth + "px";
		water_div.style.height = document.documentElement.offsetHeight + "px";
		document.body.appendChild(water_div);
	}
	return id;
};

/**
 *  @param
 *  @text
 *  @sourceBody
 * */
watermark.set = (text, sourceBody) => {
	budo_log.info("#52 text, sourceBody: ", text, sourceBody);
	setTimeout(() => {
		setWatermark(text, sourceBody);
	}, 1000);
};

export default watermark;
